var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"popup-container"},[_c('span',[_vm._v("問合せを問合せ担当者に送信しますか")]),_c('div',{staticClass:"groupBtn"},[_c('ButtonCustom',{attrs:{"title":"送信する","bg":"#0268CC"},on:{"click":_vm.handleSubmit}}),_c('ButtonCustom',{attrs:{"title":"キャンセル","bg":"#78797A"},on:{"click":_vm.onClosePopup}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }